import { PaidModal } from './PaidModal.main';

export { PaidModal };
